// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { CommunicationsListComponent } from 'src/app/modules/communications/pages/communications-list/communications-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: CommunicationsListComponent,
    canActivate: [RoleGuard],
    data: {
      communications: ['canReadCommunicationsList']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class CommunicationsRoutingModule { }
